<template>
    <div>
        <div class="card mb-4 shadow-sm">
            <img class="card-img-top" data-src="holder.js/100px225?theme=thumb&bg=55595c&fg=eceeef&text=Book your viewing here" alt="Card image cap">
            <div class="card-body">
                <p class="card-text">Book viewing</p>
                <div class="mb-4">
                    Rendered iframe tag:
                    <div>
                        <code>
                            {{ iframeTag }}
                        </code>
                    </div>
                </div>
                <div class="vd-flex justify-content-between align-items-center">
                    <code>

                    </code>
                </div>
                <div class="mb-4 vd-flex justify-content-between align-items-center">
                    <div style="width:100%" v-html="iframeTag">

                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-4 shadow-sm">
            <div class="card-body">
                <p class="card-text">Settings</p>
                <div class="form-group">
                    <label for="portalId">Portal Id</label>
                    <input v-model="portalId" type="number" class="form-control" id="portalId" aria-describedby="portalId" placeholder="Portal ID">
                    <small id="portalHelp" class="form-text text-muted">Id of the portal in Keaze system</small>
                </div>
                <div class="form-group">
                    <label for="listingId">Listing Id</label>
                    <input v-model="listingId" type="number" class="form-control" id="listingId" aria-describedby="listingId" placeholder="Listing ID">
                    <small id="listingHelp" class="form-text text-muted">Id of the listing in Keaze system (must be a listingId which belongs to the Portal)</small>
                </div>
                <div class="form-group">
                    <label for="buttonText">Button text</label>
                    <input v-model="buttonText" type="text" class="form-control" id="buttonText" aria-describedby="buttonText" placeholder="Button Text">
                    <small id="buttonTextHelp" class="form-text text-muted">Text of the rendered button</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, ref, onMounted, watch, nextTick, computed} from "@vue/composition-api";

export default defineComponent({
    name: "Example",
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    setup(props, context) {
        const portalId = ref(1001);
        const listingId = ref(2324);
        const buttonText = ref('Book now');

        const iframeTag = computed({
            get: () => {
                return '<iframe id="keaze-frame" src="'+props.url+'/portal/'+portalId.value+'/book-viewing?listing='+listingId.value+'&button='+buttonText.value+'" width="100%" height="60px" frameBorder="0"></iframe>';
            }
        });

        onMounted(() => {
            init();
        });

        function init() {

        }

        return {
            // Variables
            portalId,
            listingId,
            buttonText,
            iframeTag,
            // Functions
        };
    }
});
</script>
